import { State } from "../../core/src/states/State";
import MessagePopup from "../../core/src/ui/popups/MessagePopup";
import Locale, { LocaleId } from "../../core/src/utils/Locale";
import ViewManager from "../../core/src/utils/ViewManager";
import { DefaultLayers } from "../../core/src/utils/Layers";
import SceneView from "../../core/src/views/SceneView";
import PointerEvents from "../../core/src/const/PointerEvents";
import UIController from "../../core/src/ui/UIController";
import { UIStates } from "../../core/src/ui/UIStates";

export default class EnterRecoverState extends State {
    protected scene:SceneView;
    enter() {
        super.enter();
        let msgBox = new MessagePopup();
        UIController.setState(UIStates.IDLE);
        msgBox.show( () => {
            UIController.setState(UIStates.SPIN);
            this.exit();
        })
        msgBox.setTitle("");
        msgBox.setText(Locale.getString(LocaleId.gui_incomplete_game));
    }
}